




import CustomFields from '@/components/Templates/Admin/Membership/CustomFields/CustomFields.vue';

export default {
    name: 'AdminMembersCustomFieldsPage',
    components: { CustomFields },
};
